import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import SportPraticati from "./SportPraticati";

const DatiSportPlayer = (props) => {

    const [formData, setFormData] = useState({
        assicurato: '',
        primaryHand: '',
        primaryFoot: ''
    });

    useEffect(() => {
        if (props.profile && props.profile.idsPlay) {
            let playerData = props.profile;

            let myFormData = {};

            // console.log(playerData.idsPlay);

            myFormData.assicurato = playerData.idsPlay.insured ? 'Si' : 'No';
            myFormData.primaryHand = playerData.idsPlay.primaryHand ? playerData.idsPlay.primaryHand:'';
            myFormData.primaryFoot = playerData.idsPlay.primaryFoot ? playerData.idsPlay.primaryFoot:'';

            if(myFormData.primaryHand==='RIGHT') { myFormData.primaryHand = 'Destra'; }
            if(myFormData.primaryFoot==='RIGHT') { myFormData.primaryFoot = 'Destro'; }
            if(myFormData.primaryHand==='LEFT') { myFormData.primaryHand = 'Sinistra'; }
            if(myFormData.primaryFoot==='LEFT') { myFormData.primaryFoot = 'Sinistro'; }
            if(myFormData.primaryHand==='AMBIDEXTROUS') { myFormData.primaryHand = 'Ambidestro'; }
            if(myFormData.primaryFoot==='AMBIDEXTROUS') { myFormData.primaryFoot = 'Ambidestro'; }
            
            setFormData(myFormData);

        }
		
    }, [props]);


    return (
        <>
            <Row>
                <Form>
                    <Card className="cardAuto">
                        <Card.Header><h4 className="card-title">Informazioni generiche</h4></Card.Header>
                        <Card.Body>
                            <Row className="mt-3">
                                <Col lg={4}>
                                    <Form.Label>Mano primaria</Form.Label>
                                    <Form.Control className="sid-ro-input" type="text" value={formData.primaryHand} readOnly tabIndex={-1} />
                                </Col>
                                <Col lg={4}>
                                    <Form.Label>Piede primario</Form.Label>
                                    <Form.Control className="sid-ro-input" type="text" value={formData.primaryFoot} readOnly tabIndex={-1} />
                                </Col>
                                <Col lg={4}>
                                    <Form.Label>Assicurato</Form.Label>
                                    <Form.Control className="sid-ro-input" type="text" value={formData.assicurato} readOnly tabIndex={-1} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <SportPraticati userId={props.profile?.idsPlay?.userId} sports={props.profile?.idsPlay?.sports} />
                </Form>
            </Row>
        </>
    )
}
export default DatiSportPlayer;